'use strict';

const Backbone = require('backbone');

const ProgramQuestion = Backbone.Model.extend({
    idAttribute: 'questionId'
});

module.exports = ProgramQuestion;